import { createBrowserRouter } from "react-router-dom";
import { HomeScreen } from "../screen/HomeScreen";

export const routerDefinition = createBrowserRouter([
  {
    path: "/",
    element: <HomeScreen />,
  },
]);
